import React from 'react';
import * as S from './CustomRadioButton.styles';

type radioProps = {
  label?: string;
  id?:string;
  checked?:boolean;
  onChangeCB?:Function;
};

const RadioButton = ({label,id,checked,onChangeCB}: radioProps) => (
  <S.RadioButton key={id+label} id={id+label} htmlFor={id+label} onClick={(evt)=>{
    evt.preventDefault();
    onChangeCB && onChangeCB(id);
  }}
  >
    <input type="radio" id={id+label} name={id} value={id+label} checked={checked}/>
    <span className="checkmark"></span>
    <span className="radioLabel">{label}</span>
  </S.RadioButton>
);

export default RadioButton;
